import {FirebaseTopicModel} from "../firebase-topic-model";
import {NetPositionGameTypeData, NetPositionRawMessage} from "./net-position-topic-data";


export class NetPositionTopicModel extends FirebaseTopicModel<NetPositionRawMessage[], NetPositionGameTypeData[]>{
    getTopicName(): string {
        return "casinoGamesNetPosition";
    }

    getTopicLabel(): string {
        return "NetPosition";
    }

    protected _mapRawMessageToPublishMessage(rawMessage: NetPositionRawMessage[]): NetPositionGameTypeData[] {
        return rawMessage.map(message => message.data);
    }

    protected async _isEnabled(): Promise<boolean> {
        return await super._isEnabled() && Boolean(this.configs.NetPosition.enabled);
    }

    protected notifyListeners(rawMessage: NetPositionRawMessage[]) {

        rawMessage = rawMessage ?? [];
        if(rawMessage.length === 0) {
            return;
        }

        super.notifyListeners(rawMessage);

        if(this.services.user.isVip) {
            this.analytics.sendMessageUpdate(this.getTopicLabel(), JSON.stringify(rawMessage));
        }

    }

}